import React, { Component } from 'react';
import { InputGroup, InputGroupAddon, Input, Button } from 'reactstrap';

class AddGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      price: {
        name: '',
        isGroup: true
      }
    };
  }

  updateData = name => {
    const { price } = this.state;
    this.setState({
      price: { ...price, name: name }
    });
  };

  handleClick = () => {
    const { handleChange } = this.props;
    const { price } = this.state;
    handleChange(price);
    this.setState({ price: { name: '' } });
  };

  render() {
    return (
      <InputGroup>
        <Input
          value={this.state.price.name}
          onChange={e => this.updateData(e.target.value)}
          placeholder="Nová kategorie ceníku"
        />
        <InputGroupAddon addonType="append">
          <Button
            color="secondary"
            onClick={this.handleClick}
            disabled={!this.state.price.name.length > 0}
          >
            Vytvořit
          </Button>
        </InputGroupAddon>
      </InputGroup>
    );
  }
}

export default AddGroup;



// WEBPACK FOOTER //
// ./src/modules/Pricing/PriceList/AddGroup.js